<!-- 由 woniu6162 创建于 2021-10-27 星期三 -->
<template>
  <div class="vertical-video-rank">
    <pHead :datum="headDatum" @timeYes="timeYes" />
    <div class="ir_body">
      <div class="ir_b_tabs" ref="header">
        <template v-for="(item, index) in headList">
          <div
            :key="index"
            :class="['ir_bt_name', curTab == item.id ? 'ir_bt_is' : '']"
            @click="tapTab(item.id)"
          >
            {{ item.name }}
          </div>
        </template>
      </div>
      <div class="ir_b_wrap">
        <div v-if="refresh_time" class="ir_bw_time">{{ refresh_time }}</div>
        <pVideo :datum="listDatum" />
        <van-empty
          v-if="!listDatum.length"
          image="search"
          description="暂无数据"
        />
      </div>
    </div>
  </div>
</template>

<script>
import pHead from './ponents/p-head.vue'
import pVideo from './ponents/p-video.vue'
export default {
  name: 'vertical-video-rank',

  mixins: [],

  components: { pHead, pVideo },

  props: {},

  data() {
    return {
      headDatum: {
        date: sessionStorage['vertical-video-rank-curDay'] || new Date()
      },
      headList: [],
      refresh_time: '',
      listDatum: [],
      curTab: ''
    }
  },

  computed: {},

  watch: {
    'headDatum.date'() {
      this.loadDatum()
    },
    curTab() {
      this.loadDatum()
    }
  },

  created() {},

  mounted() {
    this.getTabs().then(() => {
      this.toRight()
      this.loadDatum()
    })
  },

  destroyed() {},

  methods: {
    // 获取tab列表
    getTabs() {
      return new Promise((resolve) => {
        let params = { tab: this.curTab }
        this.$http.getApp('member/douyin/keyWordList', params).then((rs) => {
          if (rs.data.code == 200) {
            let result = rs.data.data
            this.headList = result
            this.curTab =
              sessionStorage['vertical-video-rank-curtab'] || result[0].id
            resolve()
          }
        })
      })
    },
    loadDatum() {
      this.$toast.loading('加载')
      let params = {
        type: 'day',
        date: this.headDatum.date || new Date(),
        keyword_id: this.curTab
      }
      this.listDatum = []
      this.$http
        .getApp(`member/douyin/keyWordVideo`, params)
        .then((rs) => {
          this.$toast.clear()
          if (rs.data.code == 200) {
            let result = rs.data.data
            this.listDatum = result.data
            this.refresh_time = result.notice
          }
        })
        .catch(() => this.$toast.clear())
    },
    timeYes(val) {
      sessionStorage['vertical-video-rank-curDay'] = val
    },
    // 点击tab
    tapTab(val) {
      this.curTab = val
      sessionStorage['vertical-video-rank-curtab'] = val
    },
    toRight() {
      let el = this.$refs.header
      setTimeout(() => {
        el.scrollLeft = this.curLeft()
      }, 600)
    },
    curLeft() {
      let par = document.querySelector('.ir_b_tabs')
      let el = document.querySelector('.ir_bt_is')
      return el.offsetLeft - par.clientWidth / 5
    }
  }
}
</script>

<style lang="scss" scoped>
.vertical-video-rank {
  min-height: 100vh;
  box-sizing: border-box;
  position: relative;
  background: #f7f7f7;
  .ir_body {
    margin-top: -2.7vw;
    position: relative;
    z-index: 1;
    .ir_b_tabs {
      width: 100vw;
      height: 16vw;
      padding: 0 6vw;
      box-sizing: border-box;
      background-color: #fff;
      border-radius: 2.7vw 2.7vw 0 0;
      overflow-x: scroll;
      display: flex;
      align-items: center;
      &::-webkit-scrollbar {
        width: 0;
        height: 0;
      }
      .ir_bt_name + .ir_bt_name {
        margin-left: 6.4vw;
      }
      .ir_bt_name {
        min-width: fit-content;
        font-size: 3.7vw;
        font-weight: 600;
        color: rgba(0, 0, 0, 0.5);
      }
      .ir_bt_is {
        color: #000;
        position: relative;
        display: flex;
        justify-content: center;
        &::after {
          content: '';
          width: 6.4vw;
          height: 1.1vw;
          background-color: #ff5a5a;
          position: absolute;
          bottom: -5.6vw;
        }
      }
    }
    .ir_b_wrap {
      .ir_bw_time {
        padding: 3.2vw 3.2vw 0;
        font-size: 3.5vw;
        color: rgba(0, 0, 0, 0.5);
      }
    }
  }
}
</style>
